import { useQuery } from '@tanstack/react-query';
import { getScreensMeta } from 'shared/src/api';
import { useGetCommonParams } from '../../hooks';
import { useFilterListAtom } from 'shared/src/component/AtomicRenderer/ItemList/FilterList/Provider/filterList/useFilterListAtom';

export const useGetScreensMetaQuery = () => {
  const {
    filterListAtomValue: { screen_name },
  } = useFilterListAtom();
  const { nextToken } = useGetCommonParams();

  return useQuery({
    queryKey: ['getScreensMeta', { screen_name, nextToken }],
    queryFn: () =>
      getScreensMeta({
        screen: screen_name!,
        next_token: nextToken ?? undefined,
      }),
    enabled: screen_name !== undefined,
  });
};
